import React from "react";
import cx from "classnames";
import { InvestmentType } from "../investment-type/InvestmentType";
import { Icon, DEFAULT_ICON_SIZE } from "../icons/Icon";
import "./RiskIndicator.scss";
const DEFAULT_ICON_PRIMARY_COLOR = "var(--lysa-indicator-bonds)";
const DEFAULT_ICON_SECONDARY_COLOR = "#2ad45a9A";
const DEFAULT_ICON_PRIMARY_COLOR_RISK = "var(--lysa-indicator-stocks)";
const DEFAULT_ICON_SECONDARY_COLOR_RISK = "#1840e39A";
const investmentTypeIcon = {
    [InvestmentType.BROAD]: Icon.Earth,
    [InvestmentType.SUSTAINABLE]: Icon.Sustainable,
};
export const RiskIndicator = ({ risk = 0, investmentType = InvestmentType.BROAD, size = DEFAULT_ICON_SIZE, primaryColor = DEFAULT_ICON_PRIMARY_COLOR, secondaryColor = DEFAULT_ICON_SECONDARY_COLOR, riskPrimaryColor = DEFAULT_ICON_PRIMARY_COLOR_RISK, riskSecondaryColor = DEFAULT_ICON_SECONDARY_COLOR_RISK, }) => {
    const Icon = investmentTypeIcon[investmentType];
    return (React.createElement("div", { className: cx("risk-indicator", `risk-indicator--risk-${risk}`), style: { "--size": `${size}px` } },
        React.createElement(Icon, { size: size, primaryColor: primaryColor, secondaryColor: secondaryColor }),
        React.createElement(Icon, { size: size, primaryColor: riskPrimaryColor, secondaryColor: riskSecondaryColor })));
};
